var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/menu-alt-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 2.79995C10.9909 2.79995 9.2 4.59081 9.2 6.79995C9.2 7.47691 9.36754 8.11241 9.66275 8.66957C9.82722 8.97999 9.76993 9.36139 9.52152 9.6098L3.13137 16L4 16.8686L10.3902 10.4784C10.6386 10.23 11.02 10.1727 11.3304 10.3372C11.8875 10.6324 12.523 10.8 13.2 10.8C15.4091 10.8 17.2 9.00908 17.2 6.79995C17.2 6.52897 17.1732 6.26463 17.122 6.0093L14.9657 8.16564C14.6533 8.47806 14.1467 8.47806 13.8343 8.16564L11.8343 6.16564C11.5219 5.85322 11.5219 5.34669 11.8343 5.03427L13.9906 2.87793C13.7353 2.8268 13.471 2.79995 13.2 2.79995ZM7.6 6.79995C7.6 3.70715 10.1072 1.19995 13.2 1.19995C14.1444 1.19995 15.0364 1.43438 15.8187 1.84889C16.043 1.96773 16.1976 2.18596 16.2353 2.43697C16.273 2.68798 16.1893 2.94199 16.0098 3.12147L13.5314 5.59995L14.4 6.46858L16.8785 3.99011C17.058 3.81062 17.312 3.72696 17.563 3.76467C17.814 3.80237 18.0322 3.95696 18.1511 4.18125C18.5655 4.96353 18.8 5.85555 18.8 6.79995C18.8 9.89274 16.2928 12.4 13.2 12.4C12.4689 12.4 11.7693 12.2595 11.1276 12.0037L4.91924 18.2121C4.41156 18.7198 3.58844 18.7198 3.08076 18.2121L1.78787 16.9192C1.28018 16.4115 1.28019 15.5884 1.78787 15.0807L7.99622 8.87236C7.74049 8.23068 7.6 7.53101 7.6 6.79995Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.fb453e862c2b9a873a5df5b0af769f75.svg";
export { ForwardRef as ReactComponent };